export default "__VITE_ASSET__DVlG9v_x__"